import Lottie from 'lottie-react'
import * as React from 'react'

interface Props {
  mediaUrl: string
  loop?: boolean
}

const LazyLoadAnimation: React.FC<Props> = ({ mediaUrl, loop = true }) => {
  const [loaded, setLoaded] = React.useState(false)
  const [animation, setAnimation] = React.useState('')
  const containerRef = React.useRef(null)

  const loadAnimation = React.useCallback(async () => {
    setLoaded(true)

    const res = await fetch(mediaUrl)
    const body = await res.json()

    setAnimation(body)
  }, [])

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    const observer = new IntersectionObserver(loadAnimation)

    if (containerRef.current && !loaded && !animation) {
      observer.observe(containerRef.current)
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current)
      }
    }
  }, [containerRef, loaded, animation])

  return (
    <div ref={containerRef}>
      <Lottie style={{ height: '100%', width: '100%' }} animationData={animation} loop={loop} />
    </div>
  )
}

export default LazyLoadAnimation
